import React from 'react'
import { Box } from '@mui/material'
import { footerHeight } from '../../components/WithFooterOutlet'
import { grey } from '../../colors'

interface LoginShellProps {
  children: React.ReactNode
}

/**
 * Shared login composition shell: vertically centered column with a light outlined card.
 * Content inside stays left-aligned.
 */
export const LoginShell: React.FC<LoginShellProps> = ({ children }): JSX.Element => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      minHeight={`calc(100vh - ${footerHeight})`}
      px={3}
      py={4}
      boxSizing='border-box'
    >
      <Box
        width='100%'
        maxWidth={460}
        textAlign='left'
        bgcolor={grey[0]}
        border={`1px solid ${grey[200]}`}
        borderRadius='12px'
        boxShadow='0px 1px 2px 0px rgba(32, 41, 57, 0.05)'
        px={{ xs: 8, sm: 12 }}
        py={{ xs: 10, sm: 12 }}
      >
        {children}
      </Box>
    </Box>
  )
}
